import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';

import { Icd10DictionaryStore, injectIcd10Search } from '@lib/insurance-packages/data-access';
import { Icd10DiagnosesBrowserComponent } from '@lib/insurance-packages/ui';

/** A coverage option's diagnoses in the member profile — read-only, names from the shared МКХ-10 dictionary cache. */
@Component({
  selector: 'members-package-coverage-diagnoses',
  standalone: true,
  imports: [Icd10DiagnosesBrowserComponent],
  templateUrl: './package-coverage-diagnoses.component.html',
  host: { class: 'flex min-h-0 flex-col' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PackageCoverageDiagnosesComponent {
  protected readonly dictionary = inject(Icd10DictionaryStore);

  readonly codes = input.required<string[]>();
  readonly search = input<string>('');
  readonly fillHeight = input<boolean>(false);

  protected readonly searchState = injectIcd10Search(this.search);

  constructor() {
    this.dictionary.loadBlocks();
  }
}
